import { render, staticRenderFns } from "./pxjd-app.vue?vue&type=template&id=52f89432&scoped=true"
import script from "./pxjd-app.vue?vue&type=script&lang=js"
export * from "./pxjd-app.vue?vue&type=script&lang=js"
import style0 from "../../views/matrix-page/assets/css/base.css?vue&type=style&index=0&id=52f89432&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f89432",
  null
  
)

export default component.exports